import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Container from "src/react/layout/container";
import { color } from "src/styles/variables";
import Faqs from "src/react/components/faqs";

function ProductFaqs({ faqs }) {
  return (
    <Container>
      <H2>FAQs</H2>
      {faqs.map((faq, index) => (
        <Faqs
          key={`faq-${index}`}
          faqs={faq.items}
          title={faq.title}
          id={`faq-${index}`}
        />
      ))}
    </Container>
  );
}

ProductFaqs.propTypes = {
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          subtitle: PropTypes.string,
          content: PropTypes.string,
        })
      ),
      title: PropTypes.string,
    })
  ),
};

export default ProductFaqs;

const H2 = styled.h2`
  font-size: 36px;
  margin-bottom: 25px;
  font-weight: 800;
  color: ${color.grey};
  width: 100%;
  text-align: center;
`;
